/**
 * The store wears the gym's brand (plan R11a). Colors come in as hex from the
 * organization row; the page sets them once as CSS variables and every button,
 * chip, and status dot reads them. Button text is picked for contrast so a gym
 * with a pale yellow brand still gets readable buttons.
 */

import { DEFAULT_PRIMARY_COLOR, DEFAULT_SECONDARY_COLOR } from '@/utils/constants/brandingDefaults';
import { normalizeHexColor, readableTextOn, usablePrimaryColor } from '@/utils/branding/brandColorContrast';
import type { StoreGym } from './storeCatalogTypes';

export { normalizeHexColor, readableTextOn };

export interface StoreBrandVars {
  '--store-primary': string;
  '--store-primary-text': string;
  '--store-secondary': string;
}

export function storeBrandVars(gym: Pick<StoreGym, 'primary_color' | 'secondary_color'> | null | undefined): StoreBrandVars {
  const primary =
    normalizeHexColor(usablePrimaryColor(gym?.primary_color, gym?.secondary_color)) ?? DEFAULT_PRIMARY_COLOR;
  const secondary = normalizeHexColor(gym?.secondary_color) ?? DEFAULT_SECONDARY_COLOR;
  return {
    '--store-primary': primary,
    '--store-primary-text': readableTextOn(primary),
    '--store-secondary': secondary,
  };
}
